import { CommonGridToolBarWithFilterText, CommonGridToolBarWithFilterTextCustom } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Box, Typography, Tooltip, Drawer, Stack, Button } from "@mui/material";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { AmountFormat, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { CurrencySymbol } from '../../../Utility/Constants';

const datelist = {
    fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    dateIndex: 1,
}

function StorePurchaseGSTReport() {
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [purReturnData, setpurReturnData] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [filterData, setfilterData] = useState(datelist);
    const [totalCards, settotalCards] = useState({
        taxable_amount: 0,
        sgst_amount: 0,
        cgst_amount: 0,
        igst_amount: 0,
    });

    useEffect(() => {
        getStorePurchase()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const generateUrl = (addQuery = "") => {
        let url = `${Serviceurls.STORE_PURCHASE_HSN_REPORT}?report_type=gst&from_date=${filterData?.fromDate || ""}&to_date=${filterData?.toDate || ""}`;
        if (addQuery) {
            url += addQuery
        }
        return url
    }

    const getStorePurchase = () => {
        try {
            setisloader(true)
            const url = generateUrl();
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setpurReturnData(response.data.data || [])
                        settotalCards({
                            taxable_amount: response.data?.total_taxable_amount || 0,
                            sgst_amount: response.data?.total_sgst_amount || 0,
                            cgst_amount: response.data?.total_cgst_amount || 0,
                            igst_amount: response.data?.total_igst_amount || 0,
                        })
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPurchaseGstPrint = () => {
        const url = generateUrl("&export_type=pdf");
        try {
            RestAPIService.getAllPrint(url)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
    }

    const renderFilterScreen = () => {
        return (
            <Box className='eMed_rts_filter_container' >
                <Box className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>Filter</Typography>
                    <Tooltip>
                        <Button onClick={() => { setFilterOpen(false) }}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
                        </Button>
                    </Tooltip>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filterData.fromDate}
                            ToDate={filterData.toDate}
                            DateIndex={filterData.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                </Box>
                <Box>
                    <Stack spacing={2} direction="row" justifyContent={'center'}>
                        <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => { setfilterData(datelist) }}>Clear</Button>
                        <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => { getStorePurchase() }}>Search</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }

    const closeFilter = () => {
        setFilterOpen(false);
    }

    const tableView = () => {
        try {
            const gridToolBar = () => {
                let TextArray = [
                    { label: "From Date", value: formatDate(filterData?.fromDate || "") },
                    { label: "To Date", value: formatDate(filterData?.toDate || "") },
                  ]
                  return (
                    <Box>
                      <CommonGridToolBarWithFilterText FilterTextArray={TextArray} />
                    </Box>
                  )
            }
            purReturnData?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'tax_amount', headerName: `Taxable Amount${CurrencySymbol}`, flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.taxable_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

                },
                {
                    field: 'product__gst_percentage', headerName: 'GST %', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.product__gst_percentage || '0'}</Box>)
                },
                {
                    field: 'gst_amount', headerName: `GST Amount${CurrencySymbol}`, flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.gst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

                },
                {
                    field: 'product__gst_percentager', headerName: 'SGST %', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.product__gst_percentage ? (params?.row?.product__gst_percentage / 2) : 0}</Box>)

                },
                {
                    field: 'sgst', headerName: `SGST Amount${CurrencySymbol}`, flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.sgst || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

                },
                {
                    field: 'product__gst_percentaget', headerName: 'CGST %', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.product__gst_percentage ? (params?.row?.product__gst_percentage / 2) : 0}</Box>)

                },
                {
                    field: 'sgstt', headerName: `CGST Amount${CurrencySymbol}`, flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.sgst || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)

                },
                {
                    field: 'product__gst_percentageu', headerName: 'IGST %', flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{0}</Box>)

                },
                {
                    field: 'igst_amount', headerName: `IGST Amount${CurrencySymbol}`, flex: 0.07, type: "number",
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.igst_amount || 0)?.replace(`${CurrencySymbol}`, "")}</Box>)
                },
            ];
            return (
                <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={purReturnData}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    const msgClose = () => {
        seterrorMsg(false)
        seterrorMsgText("")
        setsuccessMsg(false)
        setsuccessMsgText("")
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
                    {AmountsCard('Taxable Amount', totalCards?.taxable_amount,)}
                    {AmountsCard('CGST Amount', totalCards?.cgst_amount,)}
                    {AmountsCard('SGST Amount', totalCards?.sgst_amount,)}
                    {/* {AmountsCard('IGST Amount', totalCards?.igst_amount,)} */}
                </Box>
                <Box>
                    <IconButton onClick={() => { setFilterOpen(true) }}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                    </IconButton>
                    <IconButton onClick={getPurchaseGstPrint}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.LabPrintIcon.default} alt='filter' />
                    </IconButton>
                    {/* <IconButton>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.ExportIcon.default} alt='filter' />
                    </IconButton> */}
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
}

export default StorePurchaseGSTReport